import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { tap, map } from 'rxjs/operators';
import { AuthService } from '../security';
import { saveAs } from 'file-saver';

@Injectable({ providedIn: 'root' })
export class UserService {
    constructor(private http: HttpClient, private authService: AuthService) {}

    getUser(id) {
        return this.http
            .get<any>(`${environment.apiUrl}/user/${id}`)
            .pipe(map(({ user }) => user));
    }

    updateUser(id, body, page) {
        return this.http.put<any>(
            `${environment.apiUrl}/user/${id}/${page}`,
            body,
        );
    }

    updateCompanyPrescription(id, companyId, body) {
        return this.http.put<any>(
            `${environment.apiUrl}/user/${id}/prescription/${companyId}`,
            body,
        );
    }

    updateCurrentUser(id, body, page) {
        return this.updateUser(id, body, page).pipe(
            tap(({ user }) => {
                user.companies = user?.companies?.map((company) => ({
                    ...company?.companyId,
                    profilId: company?.profilId?._id,
                }));
                this.authService.setCurrentUser(user);
            }),
        );
    }

    changePassword(currentpassword, newpassword, confirmpassword) {
        const body = { currentpassword, newpassword, confirmpassword };
        return this.http.post<any>(
            `${environment.apiUrl}/user/new-password`,
            body,
        );
    }

    uploadPrescriptionTemplate(prescription, id, companyId?) {
        const formData = new FormData();
        formData.append(
            'droppedFile',
            prescription.file,
            prescription.file.name,
        );
        const params = companyId ? { companyId } : undefined;

        return this.http.post<any>(
            `${environment.apiUrl}/user/${id}/prescriptionTemplate`,
            formData,
            { params },
        );
    }

    uploadAuthorization(authorization, id, companyId?) {
        const formData = new FormData();

        formData.append(
            'droppedFile',
            authorization.file,
            authorization.file.name,
        );

        const params = companyId ? { companyId } : undefined;

        return this.http.post<any>(
            `${environment.apiUrl}/user/${id}/prescriptionAuthorization`,
            formData,
            { params },
        );
    }

    addUserDocument(userId, document) {
        const formData = new FormData();

        formData.append('droppedFile', document.file, document.file.name);
        formData.append('shouldPreventUser', document.shouldPreventUser);

        return this.http.post<any>(
            `${environment.apiUrl}/user/${userId}/fileupload`,
            formData,
        );
    }

    deleteUserDocument(userId, docId) {
        return this.http.put<any>(
            `${environment.apiUrl}/user/${userId}/delete-document/${docId}`,
            {}
        );
    }

    renameUserDocument(userId, docId, newName) {
        return this.http.put(
            `${environment.apiUrl}/user/${userId}/rename-document/${docId}`,
            {
                newName,
            },
        );
    }

    getUserDocuments(id) {
        return this.http
            .get<any>(`${environment.apiUrl}/user/${id}/documents`)
    }

    downloadUserDocument(id, doc) {
        return this.http
            .get<any>(
                `${environment.apiUrl}/user/${id}/document/${doc._id}`,
                { responseType: 'blob' as 'json' },
            )
            .pipe(tap((data) => saveAs(data, doc.title)));
    }

    getAlertsRate(id) {
        return this.http.get<any>(`${environment.apiUrl}/user/${id}/alert-rate`);
    }
}
